export default __webpack_public_path__ + "static/media/logo.7fb28aa3.png";